module.exports = __webpack_public_path__ + "static/img/lun_6.02215ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_6.jpg
// module id = HNpG
// module chunks = 1